import { render } from "./WaimaiCustomerRegist.vue?vue&type=template&id=7d98bd68&scoped=true"
import script from "./WaimaiCustomerRegist.vue?vue&type=script&lang=js"
export * from "./WaimaiCustomerRegist.vue?vue&type=script&lang=js"

import "./WaimaiCustomerRegist.vue?vue&type=style&index=0&id=7d98bd68&lang=less&scoped=true"

import exportComponent from "E:\\heguang\\hotel\\src\\manage\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d98bd68"]])

export default __exports__